// Forms · CrudModalShell mode + label helpers
//
// Split out of `CrudModalShell.tsx` so that module exports components only.

export type CrudMode = "create" | "edit" | "duplicate";

/** Polish title prefix per mode — "Nowy X" / "Edytuj X" / "Duplikuj X". */
const MODE_TITLE: Record<CrudMode, string> = {
  create:    "Nowy",
  edit:      "Edytuj",
  duplicate: "Duplikuj",
};

/** Polish Save button label per mode. */
const MODE_SAVE_LABEL: Record<CrudMode, string> = {
  create:    "Utwórz",
  edit:      "Zapisz",
  duplicate: "Utwórz kopię",
};

/** Helper: title for `mode + entityName`. Exported for ModalForm reuse. */
export function defaultCrudTitle(mode: CrudMode, entityName: string): string {
  return `${MODE_TITLE[mode]} ${entityName}`;
}

/** Helper: Save button label for `mode`. Exported for ModalForm reuse. */
export function defaultCrudSaveLabel(mode: CrudMode): string {
  return MODE_SAVE_LABEL[mode];
}

